import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { GlobalsService } from "./globals.service";

@NgModule({
  imports: [CommonModule],
})
export class GlobalsModule {
  public static forRoot(): ModuleWithProviders<GlobalsModule> {
    return {
      ngModule: GlobalsModule,
      providers: [GlobalsService, DatePipe],
    };
  }
}
